<script>
  export default {
    name: 'SummaryTable',
    components: {

    },
    filters: {

    },
    mixins: [],
    props: {
      init: {
        type: Boolean,
        default: false
      },
      members: {
        type: Array,
        default() {
          return []
        }
      },
      resultData: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {

      }
    },
    computed: {

    },
    watch: {

    },
    created() {

    },
    mounted() {

    },
    methods: {
      getTotalbaofei(list) {
        const member = list
        if (!member || !member.insurances) return '-'
        const security = member.insurances
        let total = 0
        security.forEach(ins => {
          if (!ins.insuranceData) return
          ins.insuranceData.forEach(item => {
            let baof = item[2]
            baof = typeof baof === 'number' ? baof : 0
            total += baof
          })
        })
        return total.toFixed(2)
      }
    }
  }
</script>

<template>
  <div class="summary-table">
    <table
      v-if="init && members && members.length"
      class="overview-table"
    >
      <thead>
        <tr>
          <td>投保人</td>
          <td>投保日期</td>
          <td>公司</td>
          <td>保障计划</td>
          <td>险种名称</td>
          <td>保障期间</td>
          <td>交费期间</td>
          <td>保险金额(元)</td>
          <td>年交保费(元)</td>
        </tr>
      </thead>
      <tbody v-for="(tb, ti) in members">
        <tr>
          <td colspan="8">
            <span class="head-name">被保人</span><img
              class="head-image"
              :src="tb.relationImg"
              :alt="tb.clientRelation"
            ><span class="mb-name">{{ tb.name }}</span>
          </td>
          <td>{{ getTotalbaofei(resultData[tb.cid].lib) }}</td>
        </tr>
        <template v-if="resultData[tb.cid] && resultData[tb.cid].lib.insurances">
          <template v-for="(ins, idx) in resultData[tb.cid].lib.insurances">
            <template v-if="ins.resultData && ins.resultData.productGroupList && ins.resultData.productGroupList[0]">
              <template v-for="(product, ip) in ins.resultData.productGroupList[0].prodOrderList">
                <tr v-for="(item, index) in product.mulInsOrderList">
                  <template v-if="ip === 0 && index === 0">
                    <td :rowspan="ins.insuranceData.length">
                      <template v-if="ins.resultData.personData.personOrderList[1] && ins.resultData.personData.personOrderList[1].title">
                        {{ ins.resultData.personData.personOrderList[1].name }}
                      </template>
                    </td>
                    <td :rowspan="ins.insuranceData.length">
                      {{ ins.insuranceDayStr }}
                    </td>
                    <td :rowspan="ins.insuranceData.length">
                      {{ ins.companyName }}
                    </td>
                    <td :rowspan="ins.insuranceData.length">
                      {{ ins.insuranceName }}
                    </td>
                  </template>
                  <td>{{ item.name }}</td>
                  <td>{{ item.iDurationDesc }}</td>
                  <td>{{ item.pPeriodDesc }}</td>
                  <td>{{ item.baoeDesc }}</td>
                  <td>{{ item.baofDesc }}</td>
                </tr>
              </template>
            </template>
          </template>
        </template>
        <tr v-if="ti === members.length - 1">
          <td colspan="10">
            温馨提示：以上演示说明为本平台对上述产品的理解，便于保险从业人员学习、交流，演示数据仅供参考，请以实际为准。
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped>
  @import 'variable.css';

  .overview-table {
    margin-top: -41px;
    margin-bottom: 32px;
    thead {
      text-align: center;
      td {
        color: #fff;
      }
    }
    tbody {
      tr:first-child {
        td {
          background-color: #fdfdfd;
          &:last-child {
            font-weight: bold;
          }
        }
      }
      td:nth-child(1), td:nth-child(3) {
        width: 8%;
      }
      td:nth-child(5), td:nth-child(6) {
        width: 12%;
      }
      td:nth-child(7) {
        width: 9%;
      }
      td:nth-child(4), td:nth-child(9) {
        width: 10%;
      },
      td:nth-child(8) {
        width: 11%;
      }
      td:nth-child(10) {
        width: 10%;
      }
    }
    .head-name {
      margin-left: 10px;
      margin-right: 40px;
    }
    .head-image {
      display: inline-block;
      width: 36px;
      height: 36px;
      margin-right: 6px;
      vertical-align: middle;
    }
    .mb-name {
      display: inline-block;
      vertical-align: middle;
    }
  }
</style>